import {
  BUSINESS_APPROVE_REASON,
  BUSINESS_WITH_NULL,
  BUSSINESS,
  BUSSINESS_SIDES,
  BUSSINESS_SUBJECTS,
  BUSSINNESS_CATEGORY,
  SENSITIVE_CONTENT_TYPE,
  SENSITIVE_PIC_TYPE,
  SENSITIVE_WORD_TYPE,
  SENSITIVE_WORDS,
  SUBJECTS,
  USER_GROUPS,
  USER_ID,
  USER_NAME,
  BUSINESS_SOURCE_DATA
} from '../../service/constant'

const mutations = {
  setAuthInfo(state: any, payload: any) {
    state[USER_ID] = payload[USER_ID]
    state[USER_NAME] = payload[USER_NAME]
    state[USER_GROUPS] = payload[USER_GROUPS]
  },
  clearAuthInfo(state) {
    state[USER_ID] = ''
    state[USER_NAME] = ''
    state[USER_GROUPS] = []
  },
  setConstants(state, payload: any) {
    state[SENSITIVE_WORDS] = payload[SENSITIVE_WORDS]
    state[BUSSINESS] = payload[BUSSINESS]
    state[SUBJECTS] = payload[SUBJECTS]
    state[BUSSINESS_SUBJECTS] = payload[BUSSINESS_SUBJECTS]
    state[BUSSINESS_SIDES] = payload[BUSSINESS_SIDES]
    state[BUSSINNESS_CATEGORY] = payload[BUSSINNESS_CATEGORY]
    state[BUSINESS_APPROVE_REASON] = payload[BUSINESS_APPROVE_REASON]
    state[BUSINESS_WITH_NULL] = payload[BUSINESS_WITH_NULL]
    state[SENSITIVE_CONTENT_TYPE] = payload[SENSITIVE_CONTENT_TYPE]
    state[SENSITIVE_PIC_TYPE] = payload[SENSITIVE_PIC_TYPE]
    state[SENSITIVE_WORD_TYPE] = payload[SENSITIVE_WORD_TYPE]
    state[BUSINESS_SOURCE_DATA] = payload[BUSINESS_SOURCE_DATA]
  }
}

export default mutations
